module.exports = __webpack_public_path__ + "assets/img/number_times_item1.efa72eca.png";